import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const D365TalentLearnIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M128 1664H0q0-120 35-231t100-205 156-166 204-116q-56-36-100-83t-75-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 78-22 149t-64 133-98 110-129 80q-45 20-91 27t-92 11-93 8-93 17q-104 29-190 88t-149 141-96 181-35 207zm640-768q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-82-149-31q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30zm1024 895l-448 225-448-225q0-36 1-76t7-80 20-77 37-68l-193-88v582H640v-640l704-320 704 320-321 146q24 31 37 68t19 76 8 80 1 77zm-448-627l-395 180 395 180 395-180-395-180zm0 709l320-161q-1-26-4-47t-11-41-16-39-23-42l-266 121-266-121q-14 23-23 42t-16 39-9 41-5 48l319 160z" />
    </svg>
  ),
  displayName: 'D365TalentLearnIcon',
});

export default D365TalentLearnIcon;
